<div class="row">
    <div class="col-md-6 col-xl-3">
        <div class="card card-box card-box-border-bottom border-danger card-shadow-danger mb-5">
            <div class="d-flex justify-content-between align-items-center">
                <div class="p-3">
                    <div class="text-muted text-uppercase pb-2 font-size-sm">
                        Accounts
                    </div>
                    <h3 class="font-weight-bold display-4 mb-0 text-black">
                        <fa-icon [icon]="['fas', 'chevron-up']" class="font-size-lg mr-2 text-success"></fa-icon>
                        <span [countUp]="34"></span>
                        <small class="opacity-6 pl-1 text-black-50">
                            %
                        </small>
                    </h3>
                </div>
                <div class="pr-3">
                    <ngx-gauge backgroundColor="rgba(248, 50, 69, 0.15)" cap="round" class="mt-1 img-fluid"
                               foregroundColor="#f83245"
                               max="100" min="0" size="60"
                               thick="4"
                               type="full" value="34">
                    </ngx-gauge>
                </div>
            </div>
        </div>
    </div>
    <div class="col-md-6 col-xl-3">
        <div class="card card-box card-box-border-bottom border-success card-shadow-success mb-5">
            <div class="d-flex justify-content-between align-items-center">
                <div class="p-3">
                    <div class="text-muted text-uppercase pb-2 font-size-sm">
                        Subscriptions
                    </div>
                    <h3 class="font-weight-bold display-4 mb-0 text-black">
                        <span class="font-size-lg mr-2 text-success font-weight-bold">+</span>
                        <span [countUp]="35"></span>
                        <small class="opacity-6 pl-1 text-black-50">
                            sales
                        </small>
                    </h3>
                </div>
                <div class="pr-3">
                    <ngx-gauge backgroundColor="rgba(27, 201, 67, 0.15)" cap="round" class="mt-1 img-fluid"
                               foregroundColor="#1bc943"
                               max="100" min="0" size="60"
                               thick="4"
                               type="full" value="43">
                    </ngx-gauge>
                </div>
            </div>
        </div>
    </div>
    <div class="col-md-6 col-xl-3">
        <div class="card card-box card-box-border-bottom border-warning card-shadow-warning mb-5">
            <div class="d-flex justify-content-between align-items-center">
                <div class="p-3">
                    <div class="text-muted text-uppercase pb-2 font-size-sm">
                        Expenses
                    </div>
                    <h3 class="font-weight-bold display-4 mb-0 text-black">
                        <span class="font-size-lg mr-2 text-black-50 font-weight-bold">$</span>
                        <span>1,25M</span>
                    </h3>
                </div>
                <div class="pr-3">
                    <ngx-gauge backgroundColor="rgba(244, 119, 46, 0.15)" cap="round" class="mt-1 img-fluid"
                               foregroundColor="#f4772e"
                               max="100" min="0" size="60"
                               thick="4"
                               type="full" value="71">
                    </ngx-gauge>
                </div>
            </div>
        </div>
    </div>
    <div class="col-md-6 col-xl-3">
        <div class="card card-box card-box-border-bottom border-info card-shadow-info mb-5">
            <div class="d-flex justify-content-between align-items-center">
                <div class="p-3">
                    <div class="text-muted text-uppercase pb-2 font-size-sm">
                        Income
                    </div>
                    <h3 class="font-weight-bold display-4 mb-0 text-black">
                        <fa-icon [icon]="['fas', 'chevron-down']" class="font-size-lg mr-2 text-danger"></fa-icon>
                        <span [countUp]="82"></span>
                        <small class="opacity-6 pl-1 text-black-50">
                            %
                        </small>
                    </h3>
                </div>
                <div class="pr-3">
                    <ngx-gauge backgroundColor="rgba(17, 197, 219, 0.15)" cap="round" class="mt-1 img-fluid"
                               foregroundColor="#11c5db"
                               max="100" min="0" size="60"
                               thick="4"
                               type="full" value="56">
                    </ngx-gauge>
                </div>
            </div>
        </div>
    </div>
</div>